import { createContext } from 'react';

export const SizeMappingContext = createContext();
